import React, { useState } from 'react'
import NetaqInput from '../NetaqInput';
import { useTranslate } from '../TranslationText';
import { normailizeOwnerName } from '../../helper/nomalizeOwnerName';

export default function UserDropDown({ onChange, profile, setProfile }) {
    const { translate } = useTranslate();
    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];
    const subAccountId = localStorage.getItem("currentSubAccountId");

    const handelSelectedAccountChange = async (element) => {
        setProfile(element);
        onChange(element?.value);
    };
    const getSelectedAccountName = () => {
        const selectAccount = userProfile.subAccounts.filter(
            (x) => x.value == subAccountId
        );

        if (selectAccount.length > 0) {
            return selectAccount[0];
        }
        else {
            return false;
        }
    };
    const options = [{
        label:
            normailizeOwnerName(userProfile, currentLanguage, false),
        value: localStorage.getItem("EAHSUserID"),
    },
    ...subOwnerProfilesByIdData.map((a) => ({
        label:
            normailizeOwnerName(a, currentLanguage),
        value: a.value,
    }))];
    const uniqueOptions = Array.from(
        new Map(options.map(item => [item.value, item])).values()
    );

    return (
        <div>{userProfile?.isAgent != true ? (
            <>
                {subOwnerProfilesByIdData?.length > 0 &&
                    <NetaqInput
                        label={translate("web.selectedAccount", "Selected Account")}
                        name="selectAccount"
                        type="select"
                        listSelect={uniqueOptions}
                        value={profile}
                        onChange={(e) => {
                            handelSelectedAccountChange(e);
                        }}
                        placeholder={localStorage.getItem("EAHSUserFullName")}
                    />
                }
            </>
        ) : (
            <label className="capatalize_text">
                {getSelectedAccountName().registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
            </label>
        )}</div>
    )
}
